import { render, staticRenderFns } from "./PastTraineeDetails.vue?vue&type=template&id=4a9a6bb1"
import script from "./PastTraineeDetails.vue?vue&type=script&lang=js"
export * from "./PastTraineeDetails.vue?vue&type=script&lang=js"
import style0 from "./PastTraineeDetails.vue?vue&type=style&index=0&id=4a9a6bb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports